'use client'

import { useRouter } from "next/navigation";
import { ReactNode } from "react";

type GoBackLinkProps = {
    className: string,
    children: ReactNode
}

export function GoBackLink({
    className = '',
    children
} : GoBackLinkProps) {

    const router = useRouter()

    return <a href="#" className={className} onClick={() => router.back()}>{children}</a>
}